import { useGetById } from './useGetById'
import {
  ClassificationOntologyAnnotationType,
  ClassificationOntologyBaseType,
  ClassificationOntologyQuestionType,
  useGetClassification,
} from './useGetClassification'
import { useGetCommonMistakes } from './useGetCommonMistakes'

export const programs = {
  getById: useGetById,
  getCommonMistakes: useGetCommonMistakes,
  getClassification: useGetClassification,
  types: {
    ClassificationOntologyAnnotationType,
    ClassificationOntologyBaseType,
    ClassificationOntologyQuestionType,
  },
}
